// Cart-sync comparison — pure support layer.
//
// Split out of index.ts so cartContentsMatch (which drives the "Your items"
// header's Import-from-cart / Send-to-cart disabled state) can be
// unit-tested under vitest's node environment. index.ts's module-scope
// boot() call needs a real `document`, so nothing that imports it can run
// under plain node — this file has no such dependency.

/** Minimal line-item shape cartContentsMatch needs. Structurally
 *  compatible with index.ts's CartItem (which has more fields). */
export interface SyncableLineItem {
  variantId: string;
  qty: number;
}

/** True when two line-item lists carry the same `{ variantId → qty }`
 *  contents — order-independent, items with qty 0 ignored. A bare count
 *  can't detect this (2 cart items vs 2 DIFFERENT quote items is
 *  `2 === 2`). Drives QuoteBuilder.cartInSync, which greys out both the
 *  Import-from-cart and Send-to-cart buttons when they'd be no-ops. */
export function cartContentsMatch(a: SyncableLineItem[], b: SyncableLineItem[]): boolean {
  const toMap = (items: SyncableLineItem[]) => {
    const m = new Map<string, number>();
    for (const it of items) {
      if (!it.qty) continue;
      m.set(it.variantId, (m.get(it.variantId) || 0) + it.qty);
    }
    return m;
  };
  const ma = toMap(a);
  const mb = toMap(b);
  if (ma.size !== mb.size) return false;
  let matches = true;
  ma.forEach((qty, variantId) => {
    if (mb.get(variantId) !== qty) matches = false;
  });
  return matches;
}
